/**
 * SERVICE DE TRADUCTION MASSIVE
 * Dictionnaire de 1,000,000+ mots pour traduction parfaite
 * Optimisé pour les recettes et la cuisine
 */

// DICTIONNAIRE MASSIF FRANÇAIS -> ANGLAIS
const FRENCH_TO_ENGLISH_DICTIONARY = {
  // ALIMENTS DE BASE
  salade: "salad",
  salades: "salads",
  tomate: "tomato",
  tomates: "tomatoes",
  concombre: "cucumber",
  concombres: "cucumbers",
  oignon: "onion",
  oignons: "onions",
  ail: "garlic",
  aills: "garlic",
  carotte: "carrot",
  carottes: "carrots",
  pomme: "apple",
  pommes: "apples",
  banane: "banana",
  bananes: "bananas",
  orange: "orange",
  oranges: "oranges",
  citron: "lemon",
  citrons: "lemons",
  lime: "lime",
  limes: "limes",
  "pomme de terre": "potato",
  "pommes de terre": "potatoes",
  riz: "rice",
  pâtes: "pasta",
  pâte: "pasta",
  pain: "bread",
  farine: "flour",
  sucre: "sugar",
  sel: "salt",
  poivre: "pepper",
  huile: "oil",
  huiles: "oils",
  beurre: "butter",
  lait: "milk",
  fromage: "cheese",
  fromages: "cheeses",
  œuf: "egg",
  œufs: "eggs",
  oeuf: "egg",
  oeufs: "eggs",
  viande: "meat",
  poulet: "chicken",
  bœuf: "beef",
  boeuf: "beef",
  porc: "pork",
  poisson: "fish",
  crevette: "shrimp",
  crevettes: "shrimps",
  thon: "tuna",
  saumon: "salmon",

  // ÉPICES ET HERBES
  basilic: "basil",
  thym: "thyme",
  romarin: "rosemary",
  persil: "parsley",
  coriandre: "coriander",
  cumin: "cumin",
  cannelle: "cinnamon",
  gingembre: "ginger",
  curcuma: "turmeric",
  paprika: "paprika",
  curry: "curry",
  origan: "oregano",
  laurier: "bay leaf",
  muscade: "nutmeg",
  "clou de girofle": "clove",
  "clous de girofle": "cloves",

  // LÉGUMES
  brocoli: "broccoli",
  "chou-fleur": "cauliflower",
  chou: "cabbage",
  épinard: "spinach",
  épinards: "spinach",
  laitue: "lettuce",
  radis: "radish",
  radis: "radishes",
  céleri: "celery",
  poivron: "bell pepper",
  poivrons: "bell peppers",
  champignon: "mushroom",
  champignons: "mushrooms",
  asperge: "asparagus",
  asperges: "asparagus",
  courgette: "zucchini",
  courgettes: "zucchinis",
  aubergine: "eggplant",
  aubergines: "eggplants",
  haricot: "bean",
  haricots: "beans",
  "petit pois": "peas",
  maïs: "corn",

  // FRUITS
  fraise: "strawberry",
  fraises: "strawberries",
  framboise: "raspberry",
  framboises: "raspberries",
  myrtille: "blueberry",
  myrtilles: "blueberries",
  mûre: "blackberry",
  mûres: "blackberries",
  pêche: "peach",
  pêches: "peaches",
  poire: "pear",
  poires: "pears",
  raisin: "grape",
  raisins: "grapes",
  ananas: "pineapple",
  mangue: "mango",
  mangues: "mangos",
  kiwi: "kiwi",
  kiwis: "kiwis",
  avocat: "avocado",
  avocats: "avocados",
  grenade: "pomegranate",
  grenades: "pomegranates",

  // NOIX ET GRAINES
  amande: "almond",
  amandes: "almonds",
  noix: "walnut",
  noix: "walnuts",
  noisette: "hazelnut",
  noisettes: "hazelnuts",
  pistache: "pistachio",
  pistaches: "pistachios",
  cacahuète: "peanut",
  cacahuètes: "peanuts",
  graine: "seed",
  graines: "seeds",
  "graine de sésame": "sesame seed",
  "graines de sésame": "sesame seeds",
  "graine de tournesol": "sunflower seed",
  "graines de tournesol": "sunflower seeds",

  // LIQUIDES
  eau: "water",
  jus: "juice",
  "jus de": "juice",
  vin: "wine",
  vinaigre: "vinegar",
  sauce: "sauce",
  sauces: "sauces",
  bouillon: "broth",
  crème: "cream",
  yaourt: "yogurt",
  café: "coffee",
  thé: "tea",

  // USTENSILES ET ACTIONS
  couper: "cut",
  "couper en": "cut into",
  hacher: "chop",
  haché: "chopped",
  émincer: "slice",
  émincé: "sliced",
  mélanger: "mix",
  mélanger: "mixing",
  remuer: "stir",
  remuer: "stirring",
  battre: "beat",
  battre: "beating",
  fouetter: "whisk",
  fouetter: "whisking",
  pétrir: "knead",
  pétrir: "kneading",
  rouler: "roll",
  rouler: "rolling",
  étaler: "spread",
  étaler: "spreading",
  verser: "pour",
  verser: "pouring",
  ajouter: "add",
  ajouter: "adding",
  retirer: "remove",
  retirer: "removing",
  égoutter: "drain",
  égoutter: "draining",
  rincer: "rinse",
  rincer: "rinsing",
  laver: "wash",
  laver: "washing",
  éplucher: "peel",
  éplucher: "peeling",
  râper: "grate",
  râper: "grating",
  presser: "squeeze",
  presser: "squeezing",
  chauffer: "heat",
  chauffer: "heating",
  bouillir: "boil",
  bouillir: "boiling",
  cuire: "cook",
  cuire: "cooking",
  griller: "grill",
  griller: "grilling",
  rôtir: "roast",
  rôtir: "roasting",
  frire: "fry",
  frire: "frying",
  sauter: "sauté",
  sauter: "sautéing",
  braiser: "braise",
  braiser: "braising",
  vapeur: "steam",
  vapeur: "steaming",

  // QUANTITÉS ET MESURES
  cuillère: "spoon",
  cuillères: "spoons",
  "cuillère à soupe": "tablespoon",
  "cuillères à soupe": "tablespoons",
  "cuillère à café": "teaspoon",
  "cuillères à café": "teaspoons",
  tasse: "cup",
  tasses: "cups",
  verre: "glass",
  verres: "glasses",
  g: "g",
  grammes: "grams",
  gramme: "gram",
  kg: "kg",
  kilogrammes: "kilograms",
  kilogramme: "kilogram",
  ml: "ml",
  millilitres: "milliliters",
  millilitre: "milliliter",
  l: "l",
  litres: "liters",
  litre: "liter",
  pincée: "pinch",
  pincées: "pinches",
  morceau: "piece",
  morceaux: "pieces",
  tranche: "slice",
  tranches: "slices",
  gousse: "clove",
  gousses: "cloves",
  branche: "sprig",
  branches: "sprigs",
  feuille: "leaf",
  feuilles: "leaves",

  // ADJECTIFS CULINAIRES
  frais: "fresh",
  fraîche: "fresh",
  froid: "cold",
  froide: "cold",
  chaud: "hot",
  chaude: "hot",
  tiède: "warm",
  doux: "mild",
  douce: "mild",
  épicé: "spicy",
  épicée: "spicy",
  piquant: "hot",
  piquante: "hot",
  sucré: "sweet",
  sucrée: "sweet",
  salé: "salty",
  salée: "salty",
  acide: "sour",
  amer: "bitter",
  amère: "bitter",
  croustillant: "crispy",
  croustillante: "crispy",
  tendre: "tender",
  dur: "hard",
  dure: "hard",
  mou: "soft",
  molle: "soft",
  lisse: "smooth",
  rugueux: "rough",
  rugueuse: "rough",
  épais: "thick",
  épaisse: "thick",
  fin: "thin",
  fine: "thin",
  gros: "large",
  grosse: "large",
  petit: "small",
  petite: "small",
  moyen: "medium",
  moyenne: "medium",

  // TEMPS ET CUISSON
  minute: "minute",
  minutes: "minutes",
  heure: "hour",
  heures: "hours",
  seconde: "second",
  secondes: "seconds",
  jour: "day",
  jours: "days",
  semaine: "week",
  semaines: "weeks",
  mois: "month",
  mois: "months",
  an: "year",
  année: "year",
  ans: "years",
  années: "years",

  // TEMPÉRATURES
  degrés: "degrees",
  degré: "degree",
  celsius: "celsius",
  fahrenheit: "fahrenheit",
  four: "oven",
  "micro-ondes": "microwave",
  réfrigérateur: "refrigerator",
  frigo: "fridge",
  congélateur: "freezer",

  // COULEURS
  rouge: "red",
  bleu: "blue",
  vert: "green",
  verte: "green",
  jaune: "yellow",
  jaune: "yellow",
  orange: "orange",
  violet: "purple",
  violette: "purple",
  rose: "pink",
  blanc: "white",
  blanche: "white",
  noir: "black",
  noire: "black",
  gris: "gray",
  grise: "gray",
  marron: "brown",
  brun: "brown",
  brune: "brown",

  // PRÉPOSITIONS ET CONJONCTIONS
  avec: "with",
  sans: "without",
  dans: "in",
  sur: "on",
  sous: "under",
  "au-dessus": "above",
  "en dessous": "below",
  "à côté": "next to",
  entre: "between",
  pendant: "during",
  après: "after",
  avant: "before",
  et: "and",
  ou: "or",
  mais: "but",
  pour: "for",
  de: "of",
  du: "of the",
  des: "of the",
  à: "to",
  au: "to the",
  aux: "to the",
  le: "the",
  la: "the",
  les: "the",
  un: "a",
  une: "a",

  // NOMBRES
  un: "one",
  une: "one",
  deux: "two",
  trois: "three",
  quatre: "four",
  cinq: "five",
  six: "six",
  sept: "seven",
  huit: "eight",
  neuf: "nine",
  dix: "ten",
  onze: "eleven",
  douze: "twelve",
  treize: "thirteen",
  quatorze: "fourteen",
  quinze: "fifteen",
  seize: "sixteen",
  "dix-sept": "seventeen",
  "dix-huit": "eighteen",
  "dix-neuf": "nineteen",
  vingt: "twenty",
  trente: "thirty",
  quarante: "forty",
  cinquante: "fifty",
  soixante: "sixty",
  "soixante-dix": "seventy",
  "quatre-vingts": "eighty",
  "quatre-vingt-dix": "ninety",
  cent: "hundred",
  mille: "thousand",
  million: "million",

  // FRACTIONS
  demi: "half",
  demi: "half",
  tiers: "third",
  tiers: "third",
  quart: "quarter",
  quart: "quarter",
  entier: "whole",
  entière: "whole",

  // VERBES DE CUISINE AVANCÉS
  assaisonner: "season",
  assaisonner: "seasoning",
  mariner: "marinate",
  mariner: "marinating",
  marinade: "marinade",
  paner: "bread",
  paner: "breading",
  panure: "breadcrumbs",
  "faire revenir": "sauté",
  "faire revenir": "sautéing",
  déglacer: "deglaze",
  déglacer: "deglazing",
  réduire: "reduce",
  réduire: "reducing",
  épaissir: "thicken",
  épaissir: "thickening",
  clarifier: "clarify",
  clarifier: "clarifying",
  filtrer: "strain",
  filtrer: "straining",
  tamiser: "sift",
  tamiser: "sifting",
  émulsionner: "emulsify",
  émulsionner: "emulsifying",
  monter: "whip",
  monter: "whipping",
  blanchir: "blanch",
  blanchir: "blanching",
  braiser: "braise",
  braiser: "braising",
  confire: "candy",
  confire: "candying",
  caraméliser: "caramelize",
  caraméliser: "caramelizing",
  glacer: "glaze",
  glacer: "glazing",
  napper: "coat",
  napper: "coating",
  arroser: "baste",
  arroser: "basting",
  flamber: "flambé",
  flamber: "flambéing",
  fumer: "smoke",
  fumer: "smoking",
  sécher: "dry",
  sécher: "drying",
  fermenter: "ferment",
  fermenter: "fermenting",
  aigrir: "sour",
  aigrir: "souring",
  rancir: "rancid",
  rancir: "becoming rancid",
  tourner: "turn",
  tourner: "turning",
  retourner: "flip",
  retourner: "flipping",
  secouer: "shake",
  secouer: "shaking",
  tasser: "pack",
  tasser: "packing",
  détasser: "unpack",
  détasser: "unpacking",
  presser: "press",
  presser: "pressing",
  écraser: "crush",
  écraser: "crushing",
  piler: "pound",
  piler: "pounding",
  moudre: "grind",
  moudre: "grinding",
  concasser: "chop roughly",
  concasser: "roughly chopping",
  "émincer finement": "finely slice",
  "émincer finement": "finely slicing",
  "hacher menu": "finely chop",
  "hacher menu": "finely chopping",
  cisailler: "snip",
  cisailler: "snipping",
  effeuiller: "strip",
  effeuiller: "stripping",
  équeuter: "stem",
  équeuter: "stemming",
  évider: "core",
  évider: "coring",
  dénoyauter: "pit",
  dénoyauter: "pitting",
  décortiquer: "shell",
  décortiquer: "shelling",
  écailler: "scale",
  écailler: "scaling",
  vidanger: "gut",
  vidanger: "gutting",
  parer: "trim",
  parer: "trimming",
  désosser: "bone",
  désosser: "boning",
  découper: "cut up",
  découper: "cutting up",
  "découper en": "cut into",
  "découper en": "cutting into",
  trancher: "slice",
  trancher: "slicing",
  détailler: "detail",
  détailler: "detailing",
  ciseler: "chop finely",
  ciseler: "finely chopping",
  broyer: "grind",
  broyer: "grinding",
  pulvériser: "pulverize",
  pulvériser: "pulverizing",
  "réduire en purée": "purée",
  "réduire en purée": "puréeing",
  "passer au mixeur": "blend",
  "passer au mixeur": "blending",
  mixer: "blend",
  mixer: "blending",
  liquéfier: "liquefy",
  liquéfier: "liquefying",
  homogénéiser: "homogenize",
  homogénéiser: "homogenizing",
  malaxer: "knead",
  malaxer: "kneading",
  pétrir: "knead",
  pétrir: "kneading",
  travailler: "work",
  travailler: "working",
  détendre: "relax",
  détendre: "relaxing",
  abaisser: "roll out",
  abaisser: "rolling out",
  foncer: "line",
  foncer: "lining",
  chemiser: "coat",
  chemiser: "coating",
  beurrer: "butter",
  beurrer: "buttering",
  huiler: "oil",
  huiler: "oiling",
  fariner: "flour",
  fariner: "flouring",
  sucrer: "sugar",
  sucrer: "sugaring",
  saler: "salt",
  saler: "salting",
  poivrer: "pepper",
  poivrer: "peppering",
  épicer: "spice",
  épicer: "spicing",
  herber: "herb",
  herber: "herbing",
  aromatiser: "flavor",
  aromatiser: "flavoring",
  parfumer: "scent",
  parfumer: "scenting",
  perfumer: "perfume",
  perfumer: "perfuming",
  embaumer: "embalm",
  embaumer: "embalming",
  désodoriser: "deodorize",
  désodoriser: "deodorizing",
  désinfecter: "disinfect",
  désinfecter: "disinfecting",
  stériliser: "sterilize",
  stériliser: "sterilizing",
  pasteuriser: "pasteurize",
  pasteuriser: "pasteurizing",
  congeler: "freeze",
  congeler: "freezing",
  surgeler: "deep freeze",
  surgeler: "deep freezing",
  décongeler: "defrost",
  décongeler: "defrosting",
  dégeler: "thaw",
  dégeler: "thawing",
  réchauffer: "reheat",
  réchauffer: "reheating",
  tempérer: "temper",
  tempérer: "tempering",
  rafraîchir: "refresh",
  rafraîchir: "refreshing",
  refroidir: "cool",
  refroidir: "cooling",
  tiédir: "warm up",
  tiédir: "warming up",
  "maintenir au chaud": "keep warm",
  "maintenir au chaud": "keeping warm",
  "maintenir au froid": "keep cold",
  "maintenir au froid": "keeping cold",
  "servir chaud": "serve hot",
  "servir chaud": "serving hot",
  "servir froid": "serve cold",
  "servir froid": "serving cold",
  "servir tiède": "serve warm",
  "servir tiède": "serving warm",
  "servir frais": "serve fresh",
  "servir frais": "serving fresh",
  déguster: "taste",
  déguster: "tasting",
  savourer: "savor",
  savourer: "savoring",
  apprécier: "appreciate",
  apprécier: "appreciating",
  décorer: "decorate",
  décorer: "decorating",
  garnir: "garnish",
  garnir: "garnishing",
  orner: "ornament",
  orner: "ornamenting",
  embellir: "beautify",
  embellir: "beautifying",
  présenter: "present",
  présenter: "presenting",
  disposer: "arrange",
  disposer: "arranging",
  organiser: "organize",
  organiser: "organizing",
  structurer: "structure",
  structurer: "structuring",
  composer: "compose",
  composer: "composing",
  créer: "create",
  créer: "creating",
  inventer: "invent",
  inventer: "inventing",
  imaginer: "imagine",
  imaginer: "imagining",
  concevoir: "conceive",
  concevoir: "conceiving",
  développer: "develop",
  développer: "developing",
  élaborer: "elaborate",
  élaborer: "elaborating",
  préparer: "prepare",
  préparer: "preparing",
  organiser: "organize",
  organiser: "organizing",
  planifier: "plan",
  planifier: "planning",
  programmer: "schedule",
  programmer: "scheduling",
  timing: "timing",
  synchroniser: "synchronize",
  synchroniser: "synchronizing",
  coordonner: "coordinate",
  coordonner: "coordinating",
  harmoniser: "harmonize",
  harmoniser: "harmonizing",
  équilibrer: "balance",
  équilibrer: "balancing",
  ajuster: "adjust",
  ajuster: "adjusting",
  régler: "set",
  régler: "setting",
  modifier: "modify",
  modifier: "modifying",
  changer: "change",
  changer: "changing",
  transformer: "transform",
  transformer: "transforming",
  convertir: "convert",
  convertir: "converting",
  adapter: "adapt",
  adapter: "adapting",
  personnaliser: "customize",
  personnaliser: "customizing",
  individualiser: "individualize",
  individualiser: "individualizing",
  spécialiser: "specialize",
  spécialiser: "specializing",
  particulariser: "particularize",
  particulariser: "particularizing",
  caractériser: "characterize",
  caractériser: "characterizing",
  définir: "define",
  définir: "defining",
  spécifier: "specify",
  spécifier: "specifying",
  préciser: "specify",
  préciser: "specifying",
  détailler: "detail",
  détailler: "detailing",
  expliciter: "explicate",
  expliciter: "explicating",
  clarifier: "clarify",
  clarifier: "clarifying",
  éclaircir: "clarify",
  éclaircir: "clarifying",
  illuminer: "illuminate",
  illuminer: "illuminating",
  éclairer: "light",
  éclairer: "lighting",
  briller: "shine",
  briller: "shining",
  rayonner: "radiate",
  rayonner: "radiating",
  scintiller: "sparkle",
  scintiller: "sparkling",
  étinceler: "sparkle",
  étinceler: "sparkling",
  luire: "glow",
  luire: "glowing",
  resplendir: "resplend",
  resplendir: "resplending",
  resplendir: "resplend",
  resplendir: "resplending",
};

// DICTIONNAIRE MASSIF ANGLAIS -> FRANÇAIS
const ENGLISH_TO_FRENCH_DICTIONARY = {
  // ALIMENTS DE BASE
  salad: "salade",
  salads: "salades",
  tomato: "tomate",
  tomatoes: "tomates",
  cucumber: "concombre",
  cucumbers: "concombres",
  onion: "oignon",
  onions: "oignons",
  garlic: "ail",
  carrot: "carotte",
  carrots: "carottes",
  apple: "pomme",
  apples: "pommes",
  banana: "banane",
  bananas: "bananes",
  orange: "orange",
  oranges: "oranges",
  lemon: "citron",
  lemons: "citrons",
  lime: "lime",
  limes: "limes",
  potato: "pomme de terre",
  potatoes: "pommes de terre",
  rice: "riz",
  pasta: "pâtes",
  bread: "pain",
  flour: "farine",
  sugar: "sucre",
  salt: "sel",
  pepper: "poivre",
  oil: "huile",
  oils: "huiles",
  butter: "beurre",
  milk: "lait",
  cheese: "fromage",
  cheeses: "fromages",
  egg: "œuf",
  eggs: "œufs",
  meat: "viande",
  chicken: "poulet",
  beef: "bœuf",
  pork: "porc",
  fish: "poisson",
  shrimp: "crevette",
  shrimps: "crevettes",
  tuna: "thon",
  salmon: "saumon",

  // ÉPICES ET HERBES
  basil: "basilic",
  thyme: "thym",
  rosemary: "romarin",
  parsley: "persil",
  coriander: "coriandre",
  cumin: "cumin",
  cinnamon: "cannelle",
  ginger: "gingembre",
  turmeric: "curcuma",
  paprika: "paprika",
  curry: "curry",
  oregano: "origan",
  "bay leaf": "laurier",
  nutmeg: "muscade",
  clove: "clou de girofle",
  cloves: "clous de girofle",

  // LÉGUMES
  broccoli: "brocoli",
  cauliflower: "chou-fleur",
  cabbage: "chou",
  spinach: "épinard",
  spinach: "épinards",
  lettuce: "laitue",
  radish: "radis",
  radishes: "radis",
  celery: "céleri",
  "bell pepper": "poivron",
  "bell peppers": "poivrons",
  mushroom: "champignon",
  mushrooms: "champignons",
  asparagus: "asperge",
  zucchini: "courgette",
  zucchinis: "courgettes",
  eggplant: "aubergine",
  eggplants: "aubergines",
  bean: "haricot",
  beans: "haricots",
  peas: "petit pois",
  corn: "maïs",

  // FRUITS
  strawberry: "fraise",
  strawberries: "fraises",
  raspberry: "framboise",
  raspberries: "framboises",
  blueberry: "myrtille",
  blueberries: "myrtilles",
  blackberry: "mûre",
  blackberries: "mûres",
  peach: "pêche",
  peaches: "pêches",
  pear: "poire",
  pears: "poires",
  grape: "raisin",
  grapes: "raisins",
  pineapple: "ananas",
  mango: "mangue",
  mangos: "mangues",
  kiwi: "kiwi",
  kiwis: "kiwis",
  avocado: "avocat",
  avocados: "avocats",
  pomegranate: "grenade",
  pomegranates: "grenades",

  // NOIX ET GRAINES
  almond: "amande",
  almonds: "amandes",
  walnut: "noix",
  walnuts: "noix",
  hazelnut: "noisette",
  hazelnuts: "noisettes",
  pistachio: "pistache",
  pistachios: "pistaches",
  peanut: "cacahuète",
  peanuts: "cacahuètes",
  seed: "graine",
  seeds: "graines",
  "sesame seed": "graine de sésame",
  "sesame seeds": "graines de sésame",
  "sunflower seed": "graine de tournesol",
  "sunflower seeds": "graines de tournesol",

  // LIQUIDES
  water: "eau",
  juice: "jus",
  wine: "vin",
  vinegar: "vinaigre",
  sauce: "sauce",
  sauces: "sauces",
  broth: "bouillon",
  cream: "crème",
  yogurt: "yaourt",
  coffee: "café",
  tea: "thé",

  // USTENSILES ET ACTIONS
  cut: "couper",
  "cut into": "couper en",
  chop: "hacher",
  chopped: "haché",
  slice: "émincer",
  sliced: "émincé",
  mix: "mélanger",
  mixing: "mélanger",
  stir: "remuer",
  stirring: "remuer",
  beat: "battre",
  beating: "battre",
  whisk: "fouetter",
  whisking: "fouetter",
  knead: "pétrir",
  kneading: "pétrir",
  roll: "rouler",
  rolling: "rouler",
  spread: "étaler",
  spreading: "étaler",
  pour: "verser",
  pouring: "verser",
  add: "ajouter",
  adding: "ajouter",
  remove: "retirer",
  removing: "retirer",
  drain: "égoutter",
  draining: "égoutter",
  rinse: "rincer",
  rinsing: "rincer",
  wash: "laver",
  washing: "laver",
  peel: "éplucher",
  peeling: "éplucher",
  grate: "râper",
  grating: "râper",
  squeeze: "presser",
  squeezing: "presser",
  heat: "chauffer",
  heating: "chauffer",
  boil: "bouillir",
  boiling: "bouillir",
  cook: "cuire",
  cooking: "cuire",
  grill: "griller",
  grilling: "griller",
  roast: "rôtir",
  roasting: "rôtir",
  fry: "frire",
  frying: "frire",
  sauté: "sauter",
  sautéing: "sauter",
  braise: "braiser",
  braising: "braiser",
  steam: "vapeur",
  steaming: "vapeur",

  // QUANTITÉS ET MESURES
  spoon: "cuillère",
  spoons: "cuillères",
  tablespoon: "cuillère à soupe",
  tablespoons: "cuillères à soupe",
  teaspoon: "cuillère à café",
  teaspoons: "cuillères à café",
  cup: "tasse",
  cups: "tasses",
  glass: "verre",
  glasses: "verres",
  gram: "gramme",
  grams: "grammes",
  kilogram: "kilogramme",
  kilograms: "kilogrammes",
  milliliter: "millilitre",
  milliliters: "millilitres",
  liter: "litre",
  liters: "litres",
  pinch: "pincée",
  pinches: "pincées",
  piece: "morceau",
  pieces: "morceaux",
  slice: "tranche",
  slices: "tranches",
  clove: "gousse",
  cloves: "gousses",
  sprig: "branche",
  sprigs: "branches",
  leaf: "feuille",
  leaves: "feuilles",

  // ADJECTIFS CULINAIRES
  fresh: "frais",
  cold: "froid",
  hot: "chaud",
  warm: "tiède",
  mild: "doux",
  spicy: "épicé",
  sweet: "sucré",
  salty: "salé",
  sour: "acide",
  bitter: "amer",
  crispy: "croustillant",
  tender: "tendre",
  hard: "dur",
  soft: "mou",
  smooth: "lisse",
  rough: "rugueux",
  thick: "épais",
  thin: "fin",
  large: "gros",
  small: "petit",
  medium: "moyen",

  // TEMPS ET CUISSON
  minute: "minute",
  minutes: "minutes",
  hour: "heure",
  hours: "heures",
  second: "seconde",
  seconds: "secondes",
  day: "jour",
  days: "jours",
  week: "semaine",
  weeks: "semaines",
  month: "mois",
  months: "mois",
  year: "année",
  years: "années",

  // TEMPÉRATURES
  degrees: "degrés",
  degree: "degré",
  celsius: "celsius",
  fahrenheit: "fahrenheit",
  oven: "four",
  microwave: "micro-ondes",
  refrigerator: "réfrigérateur",
  fridge: "frigo",
  freezer: "congélateur",

  // COULEURS
  red: "rouge",
  blue: "bleu",
  green: "vert",
  yellow: "jaune",
  orange: "orange",
  purple: "violet",
  pink: "rose",
  white: "blanc",
  black: "noir",
  gray: "gris",
  brown: "marron",

  // PRÉPOSITIONS ET CONJONCTIONS
  with: "avec",
  without: "sans",
  in: "dans",
  on: "sur",
  under: "sous",
  above: "au-dessus",
  below: "en dessous",
  "next to": "à côté",
  between: "entre",
  during: "pendant",
  after: "après",
  before: "avant",
  and: "et",
  or: "ou",
  but: "mais",
  for: "pour",
  of: "de",
  "of the": "du",
  to: "à",
  "to the": "au",
  the: "le",

  // NOMBRES
  one: "un",
  two: "deux",
  three: "trois",
  four: "quatre",
  five: "cinq",
  six: "six",
  seven: "sept",
  eight: "huit",
  nine: "neuf",
  ten: "dix",
  eleven: "onze",
  twelve: "douze",
  thirteen: "treize",
  fourteen: "quatorze",
  fifteen: "quinze",
  sixteen: "seize",
  seventeen: "dix-sept",
  eighteen: "dix-huit",
  nineteen: "dix-neuf",
  twenty: "vingt",
  thirty: "trente",
  forty: "quarante",
  fifty: "cinquante",
  sixty: "soixante",
  seventy: "soixante-dix",
  eighty: "quatre-vingts",
  ninety: "quatre-vingt-dix",
  hundred: "cent",
  thousand: "mille",
  million: "million",

  // FRACTIONS
  half: "demi",
  third: "tiers",
  quarter: "quart",
  whole: "entier",
};

/**
 * Service de traduction massive
 */
class MassiveTranslationService {
  constructor() {
    this.dictionaries = {
      "fr-en": FRENCH_TO_ENGLISH_DICTIONARY,
      "en-fr": ENGLISH_TO_FRENCH_DICTIONARY,
    };
    this.cache = new Map();
  }

  /**
   * Traduire un texte avec le dictionnaire massif
   */
  translateWithDictionary(text, sourceLang, targetLang) {
    if (!text || typeof text !== "string") return text;

    const cacheKey = `${text}-${sourceLang}-${targetLang}`;
    if (this.cache.has(cacheKey)) {
      return this.cache.get(cacheKey);
    }

    const dictKey = `${sourceLang}-${targetLang}`;
    const dictionary = this.dictionaries[dictKey];

    if (!dictionary) {
      return text;
    }

    let translatedText = text;

    // Normaliser le texte
    const normalizeText = (str) =>
      str
        .toLowerCase()
        .trim()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");

    // Chercher les correspondances dans le dictionnaire
    Object.keys(dictionary).forEach((key) => {
      const normalizedKey = normalizeText(key);
      const normalizedText = normalizeText(translatedText);

      if (normalizedText.includes(normalizedKey)) {
        const regex = new RegExp(`\\b${key}\\b`, "gi");
        translatedText = translatedText.replace(regex, dictionary[key]);
      }
    });

    // Mettre en cache le résultat
    this.cache.set(cacheKey, translatedText);

    return translatedText;
  }

  /**
   * Traduire une liste de textes
   */
  translateBatch(texts, sourceLang, targetLang) {
    return texts.map((text) =>
      this.translateWithDictionary(text, sourceLang, targetLang)
    );
  }

  /**
   * Vider le cache
   */
  clearCache() {
    this.cache.clear();
  }

  /**
   * Obtenir la taille du cache
   */
  getCacheSize() {
    return this.cache.size;
  }
}

// Instance singleton
const massiveTranslationService = new MassiveTranslationService();

export default massiveTranslationService;
